<section
  class="w-[600px]"
  *ngFor="let letter of letterText"
  [innerHTML]="letter.textHTML"></section>
